// Helper functions
import {  BASE_API_URL } from "../Api/constants";

export const Helper = {
  DownloadFile: (url, fileName) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  
  GetStorage: (key) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch {
      return null;
    }
  },
  
  SetStorage: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  },
  
  RemoveStorage: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing from localStorage:', error);
    }
  },
  
  OnNotifyVoice: (type) => {
    // Implementation for notification sound
    console.log('Notification sound for:', type);
  },
  
  GetTokenTimeLeft: (token) => {
    // Mock implementation - you might want to decode JWT
    return 3600; // 1 hour in seconds
  },
  
  HandleError: (isError, error) => {
    if (isError) {
      console.error('Error:', error);
    }
  }
};

// Routing Manager
export const RoutingManager = {
  ApiUrl: BASE_API_URL,
   BaseUrl: import.meta.env.VITE_BASE_URL || "http://localhost:3000"
};

// Date/Time utilities
export const DateTime = {
  HandleChatDate: (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  },
  
  HandleDateWithLastWeekNames: (dateString) => {
    if (!dateString) return { Date: '', DayName: '' };
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    
    if (date.toDateString() === today.toDateString()) {
      return { Date: date.toISOString().split('T')[0], DayName: 'Today' };
    } else if (date.toDateString() === yesterday.toDateString()) {
      return { Date: date.toISOString().split('T')[0], DayName: 'Yesterday' };
    } else {
      return { 
        Date: date.toISOString().split('T')[0], 
        DayName: date.toLocaleDateString([], { weekday: 'long' })
      };
    }
  }
};

// Upload Helper
export const UploadHelper = {
  GenerateHashId: async (str) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(str + Date.now());
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('').slice(0, 16);
  },
  
  GetMessageType: (Content, Files) => {
    if (Content && Files?.length > 0) return "Mixed";
    if (Files?.length > 0) return "File";
    if (Content) return "Text";
    return "Text";
  },
  
  StartUploadQueue: async ({ Files, Socket, OnSubmit, TempId }) => {
    // Mock implementation for file upload
    console.log('Starting upload queue for', Files.length, 'files');
    return Promise.resolve();
  }
};